exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup{position:fixed;left:0;bottom:0;background-color:rgba(0,0,0,.3);height:100%;padding:1rem;z-index:10000}.popup,.popup-container{display:flex;justify-content:center;align-items:center;width:100%}.popup-container{top:25%;left:50%;max-width:500px;overflow:auto;z-index:1;background-color:#fff;border-radius:15px;flex-direction:column;padding:1rem 2rem}.popup-container .content{max-height:600px;height:100%;overflow:auto;padding:1rem 0}@media (max-width:480px){.popup-container{padding:1rem}.popup-container .buttons{flex-direction:column}.popup-container .buttons button:first-child{margin-bottom:.5rem}}.popup .buttons{width:100%;display:flex;justify-content:space-around}.popup-hidden{display:none!important}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};